module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "mt-3"
  }, [_vm._v("Date / Location")]), _vm._v(" "), (_vm.getIsCreatSingleEvent) ? _c('div', {
    staticClass: "row mt-5"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticClass: "full",
    class: {
      'color-6': _vm.validations.getSelectedEvent.product.$invalid
    }
  }, [_vm._v("\n                Product"), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [(_vm.isLoadingProductList) ? _c('span', {
    staticClass: "font-size-small dark"
  }, [_vm._v("Loading products")]) : _c('v-select', {
    attrs: {
      "searchable": true,
      "options": _vm.productList,
      "label": "name",
      "placeholder": "Select a product"
    },
    on: {
      "input": _vm.changeProductSelected
    },
    model: {
      value: (_vm.getSelectedEvent.helperProduct),
      callback: function($$v) {
        _vm.$set(_vm.getSelectedEvent, "helperProduct", $$v)
      },
      expression: "getSelectedEvent.helperProduct"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                Event Name\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.getSelectedEvent.nameAlias),
      expression: "getSelectedEvent.nameAlias"
    }],
    staticClass: "bg-lightest w-100",
    attrs: {
      "type": "text",
      "placeholder": _vm.getSelectedEvent.product ? _vm.getSelectedEvent.product.name : ''
    },
    domProps: {
      "value": (_vm.getSelectedEvent.nameAlias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.getSelectedEvent, "nameAlias", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._m(0), _vm._v(" "), _c('datepicker', {
    attrs: {
      "input-class": "bg-lightest",
      "value": _vm.getSelectedEvent.start,
      "format": "dd/MM/yyyy"
    },
    on: {
      "input": _vm.setEventStartDate
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._m(1), _vm._v(" "), _c('timepicker', {
    attrs: {
      "format": "hh:mm",
      "defaultTime": _vm.eventStartHour
    },
    on: {
      "change": _vm.setEventStartTime
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('label', {
    staticClass: "full",
    class: {
      'color-6': _vm.validations.getSelectedEvent.end.$invalid
    }
  }, [_vm._v("\n                Duration"), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")]), _vm._v(" "), (_vm.validations.getSelectedEvent.end.$invalid) ? _c('span', {
    staticClass: "color-6 fs-smaller"
  }, [_vm._v("Select a valid duration")]) : _vm._e()]), _vm._v(" "), _c('timepicker', {
    attrs: {
      "defaultTime": _vm.eventDuration,
      "availableHours": _vm.durationsPossibleHours,
      "format": "hh:mm"
    },
    on: {
      "change": _vm.setEventEndTime
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('label', {
    staticClass: "full",
    class: {
      'color-6': _vm.validations.getSelectedEvent.location.$invalid
    }
  }, [_vm._v("\n                Location"), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")]), _vm._v(" "), (_vm.validations.getSelectedEvent.location.$invalid) ? _c('span', {
    staticClass: "color-6 fs-smaller"
  }, [_vm._v("Enter a location")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.getSelectedEvent.location),
      expression: "getSelectedEvent.location"
    }],
    staticClass: "bg-lightest w-100",
    attrs: {
      "type": "text",
      "placeholder": "Type event location"
    },
    domProps: {
      "value": (_vm.getSelectedEvent.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.getSelectedEvent, "location", $event.target.value)
      }
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "full"
  }, [_vm._v("\n                Event Date"), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "full"
  }, [_vm._v("\n                Time"), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-ab75abce", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab75abce"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/EventEdit/areaDateTime.vue
// module id = 926
// module chunks = 0